import { Switch, Match } from "solid-js";
import { A } from "@solidjs/router";

type BaseLinkProps = {
  active: boolean;
  label: string;
  "data-tour-highlight-id"?: string;
};

type AsLink = BaseLinkProps & {
  as: "link";
  href: string;
};

type AsButton = BaseLinkProps & {
  as: "button";
  onClick: () => void;
};

type HeaderLinkProps = AsLink | AsButton;

const classes =
  "h-7.5 rounded-sm bg-button-bg-tertiary-default px-2.5 py-1.5 text-center text-button-small text-primary select-none hover:bg-button-bg-tertiary-hover focus-visible:outline-default active:bg-button-bg-tertiary-active active:text-button-text-tertiary-active";

const HeaderLink = (props: HeaderLinkProps) => (
  <Switch>
    <Match when={props.as === "button" && props}>
      {(buttonProps) => (
        <button
          onClick={buttonProps().onClick}
          data-active={buttonProps().active}
          class={classes}
          data-tour-highlight-id={buttonProps()["data-tour-highlight-id"]}
        >
          {buttonProps().label}
        </button>
      )}
    </Match>
    <Match when={props.as === "link" && props}>
      {(linkProps) => (
        <A
          href={linkProps().href}
          data-active={linkProps().active}
          class={classes}
          data-tour-highlight-id={linkProps()["data-tour-highlight-id"]}
        >
          {linkProps().label}
        </A>
      )}
    </Match>
  </Switch>
);

export default HeaderLink;
